module.exports = __webpack_public_path__ + "b81dc2c1c2a6c2191e740391f1ac7cf6.svg";